<template>
  <div class="tabsModal">
    <button class="close-options" @click="closeModal">
      <i class="fas fa-times"></i>
    </button>
    <OptionTabs />
  </div>
</template>

<script>
import OptionTabs from "@/components/stIves/OptionTabs";

export default {
  name: "TabsModal",
  components: {
    OptionTabs,
  },

  data() {
    return {};
  },

  methods: {
    closeModal() {
      this.$parent.closeOptionModal();
    },
  },
};
</script>

<style lang="scss" scoped>
.tabsModal {
  display: block;
  left: 0;
  right: 0;
  top: 150px;
  background-color: white;
  padding: 0;
  max-height: 70%;
  width: 90%;
  margin: auto;
  overflow-y: auto;

  border-radius: 10px;
  will-change: top, opacity;
  box-shadow: 0 0 24px 0;

  position: fixed;
  z-index: 801;

  .close-options {
    position: absolute;
    right: 20px;
    top: 20px;
    z-index: 450;
    height: 60px;
    width: 60px;
    border-radius: 50%;
    border: solid 3px #15243c;
    color: #15243c;
    background: transparent;
    font-size: 35px;
  }

  .modal-view {
    section {
      background: white !important;
    }
  }
}

.modalCloseButton {
  width: 40px;
  height: 40px;
  cursor: pointer;
  position: absolute;

  right: 10px;
  // border-radius: 10px;
  // background-color: #ffffff;
  // box-shadow: 0 0 5px 4px rgba(29, 50, 92, 0.07);
  &.top {
    top: 10px;
  }
  &.bottom {
    bottom: 10px;
  }
  i {
    font-size: 25px;
    padding: 7.5px;
    color: #4b789c;
  }
}
</style>
